/**
 * Public hotel search/book stays closed until Hotelbeds is live and certified.
 * Missing or unknown status fails closed — never sell demo/fixture hotels.
 */
export function isHotelEngineSellable(status) {
  if (!status || typeof status !== 'object') return false;
  if (status.hotelbeds_demo === true || status.hotelbeds_demo === 1) return false;
  if (status.sellable === false || status.live_sell_allowed === false) return false;
  if (status.sellable === true || status.live_sell_allowed === true) return true;
  const configured = status.hotelbeds_configured === true || status.hotelbeds_configured === 1;
  const environment = String(status.environment || '').toLowerCase();
  const gate = status.commercial_gate_signed === true || status.commercial_gate_signed === 1;
  return configured && environment === 'live' && gate;
}

export function hotelEngineClosedMessage(status) {
  const fromApi = typeof status?.message === 'string' ? status.message.trim() : '';
  if (fromApi) return fromApi;
  return 'Online hotel booking is not available. We do not sell demo or fixture hotels.';
}
